import RushPricingPage from '../landing/rush/RushPricingPage';

const PricingPageWrapper = () => <RushPricingPage />;

export default PricingPageWrapper;
